import React, { useState, useRef, useEffect } from 'react';
import StartListClass from './StartListClass';
import State from "../State";
import StartListService  from "./StartListService";
import './StartList.css';

function StartList({jsonServer}) {

	const [state] = useState(new State(useState(0)));

	const startListService = new StartListService(jsonServer, state);
	
	useEffect(() => {
		startListService.fetchClasses()
    }, []);
    
    if (state.classes.length === 0) {
		console.log('loading classes');
		return (
			<div>
				Hämtar startlista ...
			</div>
		);
	}




	const classes = startListService.sortRunners();
	const classCount = classes.length;
	const ageClasses = startListService.sortAgeRunners();

	return (
		<div>
			<button title="Uppdatera" onClick={() => {
				startListService.fetchClasses();
			}}>🔄</button>
			<h1>Startlista</h1>

			{classes.map(competitionClass => (
				<p>

					<div style={{display: "block"}}>
						<StartListClass competitionClass={competitionClass} sorting={state.sorting}/>
					</div>
				</p>
			))}
			<h1>Åldersklasser</h1>
			{ageClasses.map(ageClass => !ageClass.runnerCount ? '' : (
				<p>

					<div style={{display: "block"}} >
						<StartListClass competitionClass={ageClass} sorting={state.sorting} />
					</div>
				</p>
			))}


		</div>
	);
}

export default StartList;